import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { Autocomplete } from '@material-ui/lab';
import { wsFindBy } from 'services/WService';
import { Checkbox, FormControlLabel, Switch, Tooltip } from '@material-ui/core';

//reemplazando valores de iniciales en estado

export default function ModalMark(props) {
  const mark = props.model;

  const [selectProvs, setSelecProvs] = useState([]);
  const [providers, setProviders] = useState([]);
  const [reportMark, setReportMark] = useState(mark?.report_mark === "1");
  async function listProvideers() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
  }
  useEffect(() => {
    listProvideers();
  }, []);

  return (
    <Modal
      title="Marca"
      model={mark}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="logi/mark"
      dataForce={{ base_business_partners: selectProvs, report_mark: reportMark ? "1" : "0" }}
      state
    >
      <TextField
        label="Código"
        type="text"
        name="code"
        margin="normal"
        fullWidth
        defaultValue={mark.code || ''}
        required
      />
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={mark.description || ''}
        required
      />
      <FormControlLabel
        label="Marca para reportes"
        control={
          <Checkbox
            margin="normal"
            checked={reportMark}
            onChange={(e) => setReportMark(e.target.checked)}
            color="secondary"
          />
        }
      />
      {providers.length > 0 && !mark.id ? (
        <Autocomplete
          multiple
          disableClearable
          disableCloseOnSelect
          options={providers}
          getOptionLabel={(option) => option.CardName}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Proveedor"
              margin="normal"
              required={selectProvs.length === 0}
            />
          )}
          onChange={(e, items) => {
            let ids = items.map((item) => item.id);
            setSelecProvs(ids);
          }}
        />
      ) : undefined}
    </Modal>
  );
}
